import React from 'react';
import { StandardBanner, StandardBannerProps } from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './StandardBannerBlock.style';

export const StandardBannerBlock = (props: StandardBannerProps) => (
  <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full">
    <StandardBanner {...props} />
  </BlockContainer>
);

export type { StandardBannerProps };
